import { cn } from '@utils/cn';
import { activeStyles, styles } from '@utils/schedule/constants';
import { getScheduleState } from '@utils/schedule/helpers';
import { formatTime } from '@utils/i18n';
import { toTenantDate } from '@utils/timeZone';
import { parseJobTitle } from '@utils/textHelpers';
import { ScheduleRibbonProps } from './types';

export const ScheduleRibbon = ({ schedule, current }: ScheduleRibbonProps) => {
  const { startsAt, endsAt, status, task } = schedule;
  const variant = task?.appearance?.color || 'default';
  const { regular } = current ? activeStyles : styles[variant][getScheduleState(startsAt, status)];
  const time = [startsAt, endsAt].map((value) => formatTime(toTenantDate(value))).join(' - ');

  return (
    <div
      className={cn(
        'flex min-h-11 flex-col justify-center rounded-lg border-2 px-3 py-1.5 text-xs',
        regular,
        current && 'border-[3px] shadow-[0_2px_6px_rgba(30,34,39,.18)]',
      )}>
      <span className="flex flex-wrap items-baseline justify-between gap-x-2.5">
        <span className="font-semibold">{task?.name}</span>
        <span className="tabular-nums">{time}</span>
      </span>
      {task?.job && (
        <span className="text-[13px] font-bold [overflow-wrap:anywhere]">
          {parseJobTitle(task.job)}
        </span>
      )}
    </div>
  );
};
